import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonParams,
  ErrorMessage,
  GetCommonData,
  Params,
} from "../../../../types";
import {
  districtData,
  divisionData,
  policeStationData,
} from "../../../../types/geo/geo";
import { handleApiError } from "../../../../utils/errorHandler";

// get all Division
export const getAllDivisionAsync = createAsyncThunk<
  GetCommonData<divisionData>,
  Params<CommonParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllDivision", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const data = await AXIOS.get(BASE_API.getDivision, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.getData,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get division fail");
    return rejectWithValue(error);
  }
});

// get all District
export const getAllDistrictAsync = createAsyncThunk<
  GetCommonData<districtData>,
  Params<CommonParams & { division_id?: string }>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllDistrict", async ({ params }, { rejectWithValue }) => {
  const { division_id, ...rest } = params as CommonParams & { division_id?: string };

  try {
    const data = await AXIOS.get(BASE_API.getDistrict, {
      params: { ...rest, division_id },
      headers: {},
    });

    return {
      data: data.data?.getData,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get district fail");
    return rejectWithValue(error);
  }
});
// get all police Station
export const getAllPoliceStationAsync = createAsyncThunk<
  GetCommonData<policeStationData>,
  Params<CommonParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllPoliceStation", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const data = await AXIOS.get(BASE_API.getPoliceStation, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.getData,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get police station fail");
    return rejectWithValue(error);
  }
});
